export default {
  venue: null,
  venues: [],
  venue_configs: null,
  edit_venue_configs: null,
  new_config_venue: null,
  // addSeatSection: {},
  layers: [],
  editElement: {
    type: null,
    data: null,
  },
  colors: {
    layerBorderColor: "gray",
  },
  tableOptions: {
    rectangle: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
    square: [4, 8, 12, 16, 20, 24],
  },
  invalid_image: null
};
